import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';

const RENEW_INTERVAL = 5 * 60 * 1000;
const ACTIVITY_EVENTS = ['keydown', 'click', 'scroll'];

/**
 * Keeps an authenticated session alive while the user is active.
 * Safe to mount app-wide: no-ops when the user is not logged in.
 */
export default function useSessionRenewal() {
  const [lastActivity, setLastActivity] = useState(Date.now());

  const renewSession = useCallback(async () => {
    try {
      await axios.post('/api/renew-session', {}, { withCredentials: true });
    } catch {
      // Not logged in or renewal failed.
    }
  }, []);

  const handleUserActivity = useCallback(() => {
    setLastActivity(Date.now());
  }, []);

  useEffect(() => {
    ACTIVITY_EVENTS.forEach((event) => {
      window.addEventListener(event, handleUserActivity);
    });

    return () => {
      ACTIVITY_EVENTS.forEach((event) => {
        window.removeEventListener(event, handleUserActivity);
      });
    };
  }, [handleUserActivity]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (Date.now() - lastActivity < RENEW_INTERVAL) {
        renewSession();
      }
    }, RENEW_INTERVAL);

    return () => clearInterval(interval);
  }, [lastActivity, renewSession]);
}
